import { render, staticRenderFns } from "./LoadingSplash.vue?vue&type=template&id=4d627d78"
import script from "./LoadingSplash.vue?vue&type=script&lang=js"
export * from "./LoadingSplash.vue?vue&type=script&lang=js"
import style0 from "./LoadingSplash.vue?vue&type=style&index=0&id=4d627d78&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports